const utils = require('frontend-controller/lib/utils')

module.exports = {
	extends: [
		'/',
		'base',
		'treesManagement',
		'trees'
	],

	methods: {
		// operations
		showInsert: function(baseActionKey, buttonContext, buttonMode, actionBossComponent){
			this.deselectActiveNode();

			if(this.actions[baseActionKey]){
				return this.performAction(
					this.prepareAction(baseActionKey)
				);
			}

			return utils.promise.reject();
		},
		showDuplicate: function(baseActionKey, buttonContext, buttonMode, actionBossComponent){
			var nodeData    = this.getSelectedNodeData();

			if(this.actions[baseActionKey] && nodeData._primaryKey){

				return this.performAction(
					this.prepareAction(baseActionKey, nodeData._primaryKey)
				);
			}

			return utils.promise.reject();
		},
		delete: function(baseActionKey, buttonContext, buttonMode, actionBossComponent){
			var self = this;

			return self.performDecision(
				'confirm',
				{
					component:  self,
					title:      storage.__('hint.delete.really.' + buttonContext + '.title'),
					message:    storage.__('hint.delete.really.' + buttonContext + '.message')
				}
			).then(function(context) {
				if (context.decision.type === 'yes') {
					var nodeIndex = self.getSelectedNodeIndex();
					var nodeID = self.getSelectedNodeID();

					if(self.actions[baseActionKey] && nodeID){
						self.deselectActiveNode();
						self.setClosestNodeAsReady(nodeIndex);
						return self.performAction(
							self.prepareAction(baseActionKey, nodeID)
						).then(function(context){
							self.refreshTrees();
							return context;
						});
					}
				}

				return utils.promise.reject();
			});
		},

		sanitizeResources: function(){
			var self = this;
			var resources = {
				initialized: false,
				trees: [
					{
						name: 'Benutzer...',
						tree: [],
						nodes: {}
					}
				]
			};
			var tree = resources.trees[0].tree;
			var nodes = resources.trees[0].nodes;
			var index, additionalClasses;

			if(this.resourceData.data && !this.resourceData.initialized) {
				this.resetNodeMappings();

				utils.forEach(this.resourceData.data, function (userData) {
					resources.initialized = true;

					if(userData.attributes) {
						var user = userData.attributes;
						var _primaryKey = user[userData.primaryKey];
						var parent = '#';

						index = self.transformIDToIndex(_primaryKey, 'user', 0, tree.length);

						additionalClasses = '';
						if(user.status && user.status === 'locked'){
							additionalClasses = 'state_preview';
						}
						else if(user.status && user.status === 'inactive'){
							additionalClasses = 'state_inactive';
						}

						tree.push({
							id: index,
							parent: parent,
							text: user.code + ' | ' + user.email + ' [ ' + user.status + ' ]',
							type: 'user',
							state: {
								opened: true,
								disabled: false,
								selected: false
							},
							li_attr: {},
							a_attr: {
								class: additionalClasses
							}
						});
						user._primaryKey = _primaryKey;
						nodes[index] = user;
					}
				});

				this.resourceData = resources;
			}
		}
	},

	hooks: {
		async onDecision($element, options){
			switch(options.decisionType){
				case 'submit':
					switch(options.decisionComponent.componentClass) {
						case 'base_modal_modal':
						case 'templates_modal_modal':
							const modalContentComponent = options.decisionComponent.actions.loadContent.source.load.component
							if(modalContentComponent && modalContentComponent.hasClass('templates_propertiesForms_userPropertiesForm')){
								await modalContentComponent.submit()
                                await options.decisionComponent.hide()
							}
							break;
					}
					break;

				case 'cancel':
					switch(options.decisionComponent.componentClass) {
						case 'base_modal_modal':
						case 'templates_modal_modal':
							await options.decisionComponent.hide()
							break
					}
					break

				default:
					// TODO: ERROR;
					break
			}
		}
	},

	handlers: [
		{
			name: 'afterCancel',
			componentClass: 'templates_propertiesForms_userPropertiesForm',
			handle: function(callerComponent){
				this.deselectActiveNode();
			}
		},
		{
			name: 'onSubmitDone',
			componentClass: 'templates_propertiesForms_userPropertiesForm',
			handle: function(callerComponent, nodeData, insertPerformed){
				if(insertPerformed){
					this.config.readyNodeID       = nodeData.data.attributes[nodeData.data.primaryKey];
					this.config.readyNodeContext  = 'user';
					callerComponent.destroy();
				}
				this.refreshTrees();
			}
		}
	]
};
